import React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import { Loader } from 'rsuite'

import { AppStateType } from '../../../bll/store'
import { clearDisciplines, clearFiles, clearSpecialtyCodes, createDisciplines, createSpecialtyCodes, deleteDiscipline, deleteFile, deleteSpecialty, editDiscipline, editSpecialty, getDisciplines, getFiles, getSpecialtyCodes, uploadFilesRpd } from '../../../bll/rpd/rpdOperations'
import errorHandler from '../../../bll/errorHandler'
import openNotification from '../../_ui/notification'
import Rpd from './rpd'

const RpdContainer = (props: any) => {
    const navigate = useNavigate()

    const [isVisibleDeleteSection, setIsVisibleDeleteSection] = React.useState(false) // Видимость окна подтверждения удаления направлений подготовки и дисцплин
    const [isVisibleEditSection, setIsVisibleEditSection] = React.useState(false) // Видимость окна редактирования направлений подготовки и дисцплин
    const [actionSection, setActionSection] = React.useState('') // Раздел удаления направлений подготовки или дисцплин
    const [sectionID, setSectionID] = React.useState('') // Идентификатор
    const [sectionName, setSectionName] = React.useState('') // Наименование

    const [isVisibleLoader, setIsVisibleLoader] = React.useState(false) // Видимость компоненты Loader
    const [isVisibleLoaderDisciplines, setIsVisibleLoaderDisciplines] = React.useState(false) // Видимость компоненты Loader
    const [isVisibleLoaderFiles, setIsVisibleLoaderFiles] = React.useState(false) // Видимость компоненты Loader

    const [valueSelectedSpecialtyID, setValueSelectedSpecialtyID] = React.useState('') // Выбранный идентификатор направления подготовки
    const [valueSelectedDisciplineID, setValueSelectedDisciplineID] = React.useState('') // Выбранный идентификатор дисциплины
    const [valueFilterDirectionTraining, setValueFilterDirectionTrainig] = React.useState('') // Фильтр напралений подготовки

    const [getOpenCreateDirectionTraining, setOpenCreateDirectionTraining] = React.useState(false) // Видимость окна создания направления подготовки
    const [getOpenCreateDisciplines, setOpenCreateDisciplines] = React.useState(false) // Видимость окна создания дисциплин
    
    const [valueDirectionTraining, setValueDirectionTrainig] = React.useState('') // Наименование направления подготовки
    const [valueListDisciplines, setListDisciplines] = React.useState<any[]>([]) // Список добавляемых дисциплин

    
    React.useEffect(() => {
        if (!props.disabledTab) {
            setIsVisibleLoader(true)

            props.getSpecialtyCodes().then((result: any) => {
                setIsVisibleLoader(false)

                switch (result?.code) {
                    case "ERR_QUERY_STRING": { return openNotification("Направления подготовки...", props.msg.err_0017, "error", "bottomRight") }
                    default: errorHandler(result?.code, props.msg); break
                }
            })
        } else {
            openNotification("Доступ запрещен...", props.msg.warn_0005, "warning", "bottomRight")
            navigate('/main')
        }

        return () => {
            props.clearSpecialtyCodes()
            props.clearDisciplines()
            props.clearFiles()
        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps


    // Открытие (Закрытие) окна подтвержждение удаления направления подготовки или дискиплины
    const openDeleteSection = (isOpen: boolean, action: string = '', id: string = '', name: string = '') => {
        setSectionID(id)
        setSectionName(name)
        
        setActionSection(action)
        setIsVisibleDeleteSection(isOpen)
    }

    // Открытие (Закрытие) окна редактирования направления подготовки или дискиплины
    const openEditSection = (isOpen: boolean, action: string = '', id: string = '', name: string = '') => {
        setSectionID(id)
        setSectionName(name)
        
        setActionSection(action)
        setIsVisibleEditSection(isOpen)
    }


    // Открытие (Закрытие) окна создания направления подготовки
    const openCreateDirectionTraining = (isOpen: boolean) => {
        if (!isOpen) {
            setValueDirectionTrainig('')
            setListDisciplines([])
        }

        setOpenCreateDirectionTraining(isOpen)
    }

    // Открытие (Закрытие) окна создания дисциплин
    const openCreateDisciplines = (isOpen: boolean) => {
        if (!isOpen) { setListDisciplines([]) }
        if (isOpen) { addDiscipline() }

        setOpenCreateDisciplines(isOpen)
    }

        


    // При выборе направления подготовки, загружаем дисциплины
    const selectSpecialtyCode = (key: string) => {
        setIsVisibleLoaderDisciplines(true)
        setValueSelectedDisciplineID('')

        props.getDisciplines(key).then((result: any) => {
            setIsVisibleLoaderDisciplines(false)

            switch (result?.code) {
                case 'OK': break

                case "ERR_QUERY_STRING": { return openNotification("Дисциплины...", props.msg.err_0019, "error", "bottomRight") }
                default: errorHandler(result?.code, props.msg); break
            }
        })

        setValueSelectedSpecialtyID(key)
    }

    // При выборе дисциплины, загружаем файлы
    const selectDiscipline = (key: string) => {
        setIsVisibleLoaderFiles(true)

        props.getFiles(key).then((result: any) => {
            setIsVisibleLoaderFiles(false)

            switch (result?.code) {
                case 'OK': break

                case "ERR_QUERY_STRING": { return openNotification("Файлы...", props.msg.err_0020, "error", "bottomRight") }
                default: errorHandler(result?.code, props.msg); break
            }
        })

        setValueSelectedDisciplineID(key)
    }



    // Копирование ссылки
    const unsecuredCopyToClipboard = (text: any) => { const textArea = document.createElement("textarea"); textArea.value=text; document.body.appendChild(textArea); textArea.focus();textArea.select(); try{document.execCommand('copy')}catch(err){console.error('Unable to copy to clipboard',err)}document.body.removeChild(textArea)};
    const copyLink = async (link: string) => {
        if (link) {
            openNotification("Копирование ссылки...", 'Ссылка успешно скопирована в буфер обмена', "success", "bottomRight")
            
            if (window.isSecureContext && navigator.clipboard) {
                navigator.clipboard.writeText(link)
            } else {
                unsecuredCopyToClipboard(link)
            }            
            
        } else {
            openNotification("Копирование ссылки...", 'Не удалось скопировать ссылку.', "error", "bottomRight")
        }
    }

    const asd = (key: string) => {
        console.log(window.location.origin)
    }




    // Добавление дисциплины в список для создания
    const addDiscipline = () => {
        let newArray = []
        newArray.push('')

        setListDisciplines([...valueListDisciplines, ...newArray])
    }

    // Изменение значения дисциплины при создании
    const editValueDiscipline = (index: any) => (e: any) => {
        let newArray = [...valueListDisciplines]
        newArray[index] = e.target.value
        setListDisciplines(newArray)
    }

    // Удаление дисцплины в списке дисциплин при создании
    const deleteItemDiscipline = (index: any) => {
        setListDisciplines([
            ...valueListDisciplines.slice(0, index),
            ...valueListDisciplines.slice(index + 1, valueListDisciplines.length)
        ])
    }




    // Создание направления подготовки
    const createBtnDirectionTraining = () => {
        let validateError = false

        if (valueDirectionTraining.trim().length === 0) {
            validateError = true
            openNotification("Направление подготовки...", 'Необходимо ввести код направления подготовки / специальности', "error", "bottomLeft")
        }

        if (valueListDisciplines.length > 0) {
            valueListDisciplines.forEach((item: any) => {
                if (item.trim().length === 0) {
                    validateError = true
                }
            })

            if (validateError) { 
                openNotification("Направление подготовки...", 'Дисциплины должны быть все заполнены, пустые поля необходимо удалить или заполнить', "error", "bottomLeft")
            }
        }

        if (!validateError) {
            props.createSpecialtyCodes(valueDirectionTraining, valueListDisciplines).then((result: any) => {
                switch (result?.code) {
                    case 'OK': 
                        openCreateDirectionTraining(false)
                    break

                    case "ERR_QUERY_STRING": { return openNotification("Направления подготовки...", props.msg.err_0045, "error", "bottomRight") }
                    default: errorHandler(result?.code, props.msg); break
                }
            })
        }
    }

    // Создание дисциплин
    const createBtnDisciplines = () => {
        let validateError = false

        if (valueListDisciplines.length > 0) {
            valueListDisciplines.forEach((item: any) => {
                if (item.trim().length === 0) {
                    validateError = true
                }
            })

            if (validateError) { 
                openNotification("Дисциплины...", 'Дисциплины должны быть все заполнены, пустые поля необходимо удалить или заполнить', "error", "bottomLeft")
            }
        }

        if (!validateError) {
            props.createDisciplines(valueSelectedSpecialtyID, valueListDisciplines).then((result: any) => {
                setIsVisibleLoader(false)

                switch (result?.code) {
                    case 'OK': 
                    openCreateDisciplines(false)
                    break

                    case "ERR_QUERY_STRING": { return openNotification("Дисциплины...", props.msg.err_0046, "error", "bottomRight") }
                    default: errorHandler(result?.code, props.msg); break
                }
            })
        }
    }

    // Загрузка файлов на сервер
    const fileUploader = (fileList: any) => {
        fileList.forEach((file: any) => {
            props.uploadFilesRpd(file, valueSelectedDisciplineID, file.name).then((result: any) => {
                switch (result?.code) {
                    case "ERR_QUERY_STRING": { return openNotification("Ошибка загрузки файла...", props.msg.err_0022, "error", "bottomRight") }
                    case "ERR_FILE_NOT_FOUND": { return openNotification("Ошибка загрузки файла...", props.msg.err_0013, "error", "bottomRight") }
                    case "ERR_FILE_EXTNAME": { return openNotification("Ошибка загрузки файла...", props.msg.err_0023, "error", "bottomRight") }
                    case "ERR_FILE_SIZE": { return openNotification("Ошибка загрузки файла...", props.msg.err_0024, "error", "bottomRight") }
                    default: errorHandler(result?.code, props.msg); break
                }
            })
        })
    }



    // Редактирование направление подготовки или дисциплин
    const editBtnSection = () => {
        if (actionSection === 'specialty') {
            props.editSpecialty(sectionID, sectionName).then((result: any) => {
                switch (result?.code) {
                    case "ERR_QUERY_STRING": { return openNotification("Редактирование направления...", props.msg.err_0050, "error", "bottomRight") }
                    default: errorHandler(result?.code, props.msg); break
                }
            })
        }

        if (actionSection === 'discipline') {
            props.editDiscipline(sectionID, sectionName, valueSelectedSpecialtyID).then((result: any) => {
                switch (result?.code) {
                    case "ERR_QUERY_STRING": { return openNotification("Редактирование дисциплины...", props.msg.err_0048, "error", "bottomRight") }
                    default: errorHandler(result?.code, props.msg); break
                }
            })
        }

        openEditSection(false)
    }
    


    // Удаление направление подготовки или дисциплин
    const deleteBtnSection = () => {
        if (actionSection === 'specialty') {
            props.deleteSpecialty(sectionID, sectionName).then((result: any) => {
                switch (result?.code) {
                    case "ERR_DISCIPLINES_LIST": { return openNotification("Удаление направления...", 'Для начала необходимо удалить все дисциплины у данного направления подготовки.', "error", "bottomRight") }
                    case "ERR_QUERY_STRING": { return openNotification("Удаление направления...", props.msg.err_0049, "error", "bottomRight") }
                    default: errorHandler(result?.code, props.msg); break
                }
            })    
        }

        if (actionSection === 'discipline') {
            props.deleteDiscipline(sectionID, sectionName, valueSelectedSpecialtyID).then((result: any) => {
                switch (result?.code) {
                    case "ERR_FILES_LIST": { return openNotification("Удаление дисциплины...", 'Для начала необходимо удалить все файлы у данной дисциплины.', "error", "bottomRight") }
                    case "ERR_QUERY_STRING": { return openNotification("Удаление дисциплины...", props.msg.err_0047, "error", "bottomRight") }
                    default: errorHandler(result?.code, props.msg); break
                }
            })    
        }

        openDeleteSection(false)
    }

    // Удаление файла
    const deleteBtnFiles = (filetID: string, fileName: string) => {
        setIsVisibleLoaderFiles(true)

        props.deleteFile(filetID, fileName, valueSelectedDisciplineID).then((result: any) => {
            setIsVisibleLoaderFiles(false)

            switch (result?.code) {
                case "ERR_QUERY_STRING": { return openNotification("Удаление файла...", props.msg.err_0021, "error", "bottomRight") }
                default: errorHandler(result?.code, props.msg); break
            }
        })
    }


    // Свойства передаваемые в компоненту
    const propsToComponent = {
        isVisibleDeleteSection, openDeleteSection, // Видимость окна подтверждения удаления направлений подготовки и дисцплин
        isVisibleEditSection, openEditSection, // Видимость окна редактирования направлений подготовки и дисцплин
        actionSection, // Раздел удаления направлений подготовки или дисцплин
        sectionName, setSectionName, // Наименование
    

        valueFilterDirectionTraining, setValueFilterDirectionTrainig, // Фильтр напралений подготовки

        isVisibleLoaderDisciplines, // Видимость компоненты Loader
        isVisibleLoaderFiles, // Видимость компоненты Loader

        selectSpecialtyCode, // При выборе направления подготовки, загружаем дисциплины
        selectDiscipline, // При выборе дисциплины, загружаем файлы

        asd,

        openCreateDirectionTraining, // Открытие (Закрытие) окна создания направления подготовки
        getOpenCreateDirectionTraining, // Видимость окна создания направления подготовки

        openCreateDisciplines, // Открытие (Закрытие) окна создания дисциплин
        getOpenCreateDisciplines, // Видимость окна создания дисциплин

        valueDirectionTraining, setValueDirectionTrainig, // Наименование направления подготовки
        valueListDisciplines, setListDisciplines, // Список добавляемых дисциплин

        addDiscipline, // Добавление дисциплины в список для создания
        editValueDiscipline, // Изменение значения дисциплины при создании
        deleteItemDiscipline, // Удаление дисцплины в списке дисциплин при создании
        createBtnDirectionTraining, // Создание направления подготовки
        createBtnDisciplines, // Создание дисциплин
        fileUploader, // Загрузка файлов на сервер
        
        deleteBtnSection, // Удаление направление подготовки или дисциплин
        editBtnSection, // Редактирование направление подготовки или дисциплин
        deleteBtnFiles, // Удаление файла
        copyLink, // Копирование ссылки
    }

    return (
        <>
            {isVisibleLoader
                ? <div style={{ height: "100%", position: "relative" }}><Loader center size="md" content="Загрузка данных..." vertical /> </div>
                : <Rpd {...props} {...propsToComponent} />
            }
        </>
    )
}

let mapState = (state: AppStateType) => {
    return {
        msg: state.msg,
        specialtyCodesList: state.rpd.specialtyCodesList,
        disciplinesList: state.rpd.disciplinesList,
        filesList: state.rpd.filesList,
    }
}

export default compose(connect(mapState, {
    getSpecialtyCodes, clearSpecialtyCodes, deleteSpecialty, editSpecialty,
    getDisciplines, clearDisciplines, deleteDiscipline, editDiscipline,
    getFiles, clearFiles,
    createSpecialtyCodes, createDisciplines, 
    uploadFilesRpd, deleteFile
}))(RpdContainer)